var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossChainBridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2502 5.23963C17.9783 5.08265 17.6699 5 17.3559 5C17.0419 5 16.7335 5.08265 16.4616 5.23963L4.89433 11.9185C4.62187 12.0747 4.39591 12.3007 4.23968 12.5731C4.08268 12.845 4.00001 13.1535 4 13.4675V26.8216C4.00001 27.1355 4.08266 27.444 4.23965 27.7159C4.39663 27.9878 4.62242 28.2136 4.89433 28.3705L17.3559 35.5645V22.1353L15.6263 21.1408V19.15L17.3505 18.1537L19.0748 19.15L30.7011 12.4336L18.2502 5.23963Z",
    fill: "url(#paint0_linear_597_13556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1714 19.6274L30.7099 12.4335V25.8645L32.4341 26.8608V28.8498L30.7099 29.846L28.9874 28.8498L17.3557 35.5662L29.8155 42.7601C30.0874 42.9171 30.3959 42.9998 30.7099 42.9998C31.0238 42.9998 31.3323 42.9171 31.6042 42.7601L43.1714 36.0831C43.4436 35.926 43.6696 35.6999 43.8266 35.4276C43.9836 35.1554 44.0661 34.8466 44.0658 34.5323V21.1764C44.0657 20.8625 43.9831 20.554 43.8261 20.2821C43.6691 20.0102 43.4433 19.7844 43.1714 19.6274Z",
    fill: "url(#paint1_linear_597_13556)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9856 28.8498L22.3085 24.9952V23.0044L24.0328 22.0099L30.7099 25.8645V12.4335L19.08 19.1499L17.3557 18.1536L15.6315 19.1499V21.1389L17.3559 22.1353L17.3557 35.5662L28.9856 28.8498Z",
    fill: "#3F237B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_13556",
    x1: 27.6911,
    y1: 5.91391,
    x2: 17.6321,
    y2: 41.1737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_13556",
    x1: 3095.47,
    y1: 4687.71,
    x2: 9049.03,
    y2: 5016.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChainBridge);
export default __webpack_public_path__ + "static/media/cross-chain-bridge.404f8d7c583ffe8df271808dd984670a.svg";
export { ForwardRef as ReactComponent };